import React, { useContext, useEffect, useState } from 'react';
import { Button, Input } from '../../components';
import AuthContext from '../../context/authContext/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  ModalProvider,
  useModal,
} from '../../components/common/modal/ModalContext';
import ForgotPasswordModal from '../user-setting/ForgotPassword';

const Login = () => {
  const { userCredential, setUserCredential, handleLogin, isLoggedIn, error } =
    useContext(AuthContext);
  const { openModal, closeModal } = useModal();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setUserCredential({ ...userCredential, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (isLoggedIn) navigate('/');
  }, [isLoggedIn, navigate]);

  const handleForgotPassword = () => {
    openModal(
      <ForgotPasswordModal closeModal={closeModal} />,
      'Forgot Password',
      'isCenter',
    );
  };

  return (
    <div className="flex lg:flex-row flex-col min-h-screen bg-[#EE2D24]">
      <div className="lg:basis-1/2 relative ">
        <div className="absolute text-white top-0 left-0 right-0 bottom-0 lg:flex hidden justify-center items-center">
          <img
            loading="lazy"
            src="images/illustration_2.webp"
            width="450px"
            className=""
            alt="Illustration"
          />
        </div>
      </div>
      <div
        className="lg:basis-1/2 mt-auto mb-auto lg:w-80 w-full absolute lg:static flex justify-center items-center lg:border-l-4 border-white"
        style={{
          backgroundImage: 'url(images/illustration_1.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: '100vh', // Full height
          width: '100vw', // Full width
        }}
      >
        <div className="shadow-2xl rounded-3xl lg:my-10 mt-20 sm:mt-auto sm:mb-auto lg:mx-28 px-8 lg:px-12 py-8 lg:py-16 bg-black/70 backdrop-blur-[3px] drop-shadow-xl p-10 text-white">
          <div className="text-2xl">Welcome</div>
          <div className="font-500 text-5xl pb-10">Sign in</div>
          <form onSubmit={handleLogin}>
            <div className="lg:w-80">
              <Input
                type="email"
                label="Email"
                placeholder="Enter Your Email"
                value={userCredential.email}
                onChange={handleChange}
                name="email"
                error={error?.email}
              />
            </div>
            <div className="lg:w-80">
              <Input
                label="Password"
                type="password"
                value={userCredential.password}
                onChange={handleChange}
                name="password"
                placeholder="Enter Your Password"
                error={error?.password}
              />
            </div>
            <div className="text-right px-2 py-2 text-sky-400 cursor-pointer">
              <span onClick={handleForgotPassword}>Forgot Password?</span>
            </div>
            <div className="text-red-600 text-sm text-center font-semibold">
              {error?.message}
            </div>
            <div className="flex justify-center mt-8">
              <Button className="primary" style={{ width: '90%' }}>
                Sign in
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const LoginApp = () => (
  <ModalProvider>
    <Login />
  </ModalProvider>
);

export default LoginApp;
